<!-- 加载更多按钮组件 -->
<template>
  <div class="wrap">
    <a-button class="load-more">
      <span v-if="iconPosition === 'left'"> {{ $t(loadMsg) }} </span>
      <template #icon>
        <span v-if="iconPosition === 'right'"> {{ $t(loadMsg) }} </span>
        <img :class="{turn:status=='loading'}" src="@/assets/images/roll/ref.png" alt="" />
      </template>
    </a-button>
  </div>
</template>

<script setup>
import { ref } from "vue";
import i18n from "@/i18n";
const { t: $t, locale } = i18n.global;
// 创建响应式数据
const nomoreText = ref("实在没有了");

const props = defineProps({
  iconPosition: {
    type: String,
    default: "right",
  },
  status: {
    type: String,
    default: "loading", //loadMore loading  noMore
  },
  loadMsg: {
    type: String,
    default: '',
  },
});
</script>
<style lang="scss" scoped>
.wrap {
  display: flex;
  justify-content: center;

  .load-more {
    border-radius: 0.25rem;
    width: 2.3rem;
    height: 0.5rem;
    background-color: #1b2132;
    font-size: 0.14rem;
    font-weight: bold;
    color: #5d6984;
    @extend %flex-all-center;
    &:hover {
      background-color: #212738;

    }
    span {
      font-size: 0.14rem;
      font-weight: bold;
    }
    img {
      width: 0.14rem;
      height: 0.16rem;
      margin-right: 0.1rem;
      margin-left: 0.1rem;
    }
    .turn {
      animation: turn 2s linear infinite;
    }
    /* 
turn : 定义的动画名称
10s : 动画时间
linear : 动画平滑
infinite :使动画无限循环
transform:rotate(旋转角度)
%0:动画开始
%100:动画结束
*/
    @keyframes turn {
      0% {
        transform: rotate(360deg);
      }

      20% {
        transform: rotate(288deg);
      }

      40% {
        transform: rotate(216deg);
      }

      60% {
        transform: rotate(144deg);
      }

      80% {
        transform: rotate(72deg);
      }

      100% {
        transform: rotate(0deg);
      }
    }
  }
}
</style>
